import { serializeDatesDeep } from "@/utils/utilsGrcpRest";

const DATE_ONLY_PROJECT_FIELDS = [
  "buildingPermitAcquisitionDate",
  "buildingPermitRequestDate",
  "dateWorkDeadline",
  "dceDate",
  "rictPublicationDate",
  "safetyCommissionDate",
  "safetyRegisterRevisionDate",
  "technicalChecksEndDate",
  "opeStartDate",
  "signDate",
  "invoiceDateStart",
  "invoiceDateLastDeadline",
];

export const serializeProjectDates = (project) => {
  const serialized = serializeDatesDeep(project);
  DATE_ONLY_PROJECT_FIELDS.forEach((field) => {
    if (serialized[field]) {
      serialized[field] = serialized[field].slice(0, 10);
    }
  });
  return serialized;
};
